import joyEmoji from './joy.png';
import openMouthEmoji from './openMouth.png';
import heartEyesEmoji from './heartEyes.png';
import cryEmoji from './cry.png';
import clapEmoji from './clap.png';
import fireEmoji from './fire.png';
import tadaEmoji from './tada.png';
import emoji100 from './emoji100.png';

export const emojis = {
  ':joy:': joyEmoji,
  ':open_mouth:': openMouthEmoji,
  ':heart_eyes:': heartEyesEmoji,
  ':cry:': cryEmoji,
  ':clap:': clapEmoji,
  ':fire:': fireEmoji,
  ':tada:': tadaEmoji,
  ':100:': emoji100,
};
